module.exports = __webpack_public_path__ + "static/media/icon-tick.447a23b8.svg";